import { z } from "zod";

import { conditionOperatorSchema } from "./enums";

const threePartConditionSchema = z.object({
	id: z.string(),
	field: z.string(),
	operator: conditionOperatorSchema,
	valueExpression: z.string(),
});
export type ThreePartCondition = z.infer<typeof threePartConditionSchema>;

const conditionalGroupSchema = z.object({
	id: z.string(),
	andConditions: z.array(threePartConditionSchema),
});
export type ConditionalGroup = z.infer<typeof conditionalGroupSchema>;

export const conditionalSchema = z.object({
	orGroupings: z.array(conditionalGroupSchema),
});
export type Conditional = z.infer<typeof conditionalSchema>;
